// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Mobile"){
  $w("#button17").show();
}
});

let locale = wixWindow.multilingual.currentLanguage;  // "en-US"
if (wixWindow.multilingual.currentLanguage ==='es') { locale ='en'}
if (wixWindow.multilingual.currentLanguage ==='de') { locale ='en'}
if (wixWindow.multilingual.currentLanguage ==='fr') { locale ='en'}




$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

import wixLocation from 'wix-location';




$w.onReady(function () {
	// Write your JavaScript here
	Date.prototype.addDays = function(days) {
     var date = new Date(this.valueOf());
     date.setDate(date.getDate() + days);
     return date;
 }
$w("#datePicker2").value = $w("#datePicker1").value.addDays(1);
	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

export function button2_click(event) {
	
}

export function datePicker1_change(event) {
	$w("#datePicker2").value = $w("#datePicker1").value.addDays(1);
}


export function datePicker2_change(event) {
		// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	}




export function button2_mouseIn(event) {
	let arrivo = $w('#datePicker1').value;
	
  
  var dd = String(arrivo.getDate()).padStart(2, '0');
	var mm = String(arrivo.getMonth() + 1).padStart(2, '0'); //January is 0!
	var yyyy = arrivo.getFullYear();
	arrivo = dd + '/' + mm + '/' + yyyy;

  let partenza = $w("#datePicker2").value;

  var pdd = String(partenza.getDate()).padStart(2, '0');
	var pmm = String(partenza.getMonth() + 1).padStart(2, '0'); //January is 0!
	var pyyyy = partenza.getFullYear();
	partenza = pdd + '/' + pmm + '/' + pyyyy;

  let adulti = $w("#dropdown1").value;

let url = "https://grandhotelderose.kross.travel/book/step1?from="+arrivo+"&to="+partenza+"&kross_lang="+locale+"&guests_rooms="+adulti;

		// console.log(url);
	$w("#button2").target = "_blank";
	$w("#button2").link = url;
	// wixLocation.to(url);
	// console.log(arrivo, partenza, notti, adulti, bambini);
}



export function datePicker2_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}
